import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00080InstallationAlarmRXComponent } from './P00080/Installation/p00080-installation-alarm-rx/p00080-installation-alarm-rx.component';
import { P00080InstallationAlarmPHComponent } from './P00080/Installation/p00080-installation-alarm-ph/p00080-installation-alarm-ph.component';
import { P00080InstallationFinish } from './P00080/Installation/P00080InstallationFinish';
import { P00080InstallationReset } from './P00080/Installation/P00080InstallationReset';
import { P00080CardAltimeoControleComponent } from './P00080/Altimeo/cards/p00080-card-altimeo-controle/p00080-card-altimeo-controle.component';
import { P00080CardAltimeoStatutComponent } from './P00080/Altimeo/cards/p00080-card-altimeo-statut/p00080-card-altimeo-statut.component';
import { P00080Alarm } from './P00080/Alarm/P00080Alarm';
import { P00080AltimeoMiseEnOeuvreRxComponent } from './P00080/Altimeo/miseenoeuvre/p00080-altimeo-mise-en-oeuvre-rx/p00080-altimeo-mise-en-oeuvre-rx.component';
import { P00080AltimeoMiseEnOeuvrePhComponent } from './P00080/Altimeo/miseenoeuvre/p00080-altimeo-mise-en-oeuvre-ph/p00080-altimeo-mise-en-oeuvre-ph.component';

import { P00080AltimeoMiseEnOeuvreInit } from './P00080/Altimeo/miseenoeuvre/P00080AltimeoMiseEnOeuvreInit';
import { P00080AltimeoControleComponent } from './P00080/Altimeo/cps/p00080-altimeo-controle/p00080-altimeo-controle.component';
import { P00080AltimeoParametersComponent } from './P00080/Altimeo/cps/p00080-altimeo-parameters/p00080-altimeo-parameters.component';
import { P00080AltimeoStatutComponent } from './P00080/Altimeo/cps/p00080-altimeo-statut/p00080-altimeo-statut.component';
import { P00076InstallationVannesComponent } from './P00076/Installation/p00076-installation-vannes/p00076-installation-vannes.component';
import { P00076InstallationConsommationComponent } from './P00076/Installation/p00076-installation-consommation/p00076-installation-consommation.component';
import { P00076InstallationVoletImmergeComponent } from './P00076/Installation/p00076-installation-volet-immerge/p00076-installation-volet-immerge.component';
import { P00039 } from './P00039';
import { P00042 } from './P00042';
import { P00076InstallationFinish } from './P00076/Installation/P00076InstallationFinish';
import { P00076InstallationReset } from './P00076/Installation/P00076InstallationReset';
import { P00076CardConstanceControleComponent } from './P00076/Constance/cards/p00076-card-constance-controle/p00076-card-constance-controle.component';
import { P00076CardConstanceStatutComponent } from './P00076/Constance/cards/p00076-card-constance-statut/p00076-card-constance-statut.component';
import { P00076ConstanceStatutComponent } from './P00076/Constance/cps/p00076-constance-statut/p00076-constance-statut.component';
import { P00076ConstanceParametersComponent } from './P00076/Constance/cps/p00076-constance-parameters/p00076-constance-parameters.component';
import { P00076ConstanceControleComponent } from './P00076/Constance/cps/p00076-constance-controle/p00076-constance-controle.component';
import { P00076ConstanceMiseEnOeuvreInit } from './P00076/Constance/miseenoeuvre/P00076ConstanceMiseEnOeuvreInit';
import { P00076ConstanceMiseEnOeuvreNiveauEauComponent } from './P00076/Constance/miseenoeuvre/p00076-constance-mise-en-oeuvre-niveau-eau/p00076-constance-mise-en-oeuvre-niveau-eau.component';
import { P00037FunctionHistoryGraphComponentComponent } from './P00037/Component/p00037-function-history-graph-component/p00037-function-history-graph-component.component';
import { P00076FunctionHistoryGraphComponent } from './P00076/Component/p00076-function-history-graph/p00076-function-history-graph.component';

export class P00076Data {
  coCModeFonctionnement: number = 0;
  coCAjustementNiveauMesure: number = 0;
  coCLancementCalibration: number = 0;
  coCResetUsine: number = 0;
  coCConfirmationOTA: number = 0;
  coCResetManuelDureeRemplissage: number = 0;
  coCResetManuelDureeVidange: number = 0;

  coIPresenceVanneRemplissage: number = 0;
  coIPresenceVanneVidange: number = 0;
  coIConfigurationProduit: number = 0;
  coIActivationVoletImmerge: number = 0;
  coISurfaceBassin: number = 0;
  coISourceReferenceDebit: number = 0;

  coPConsigneRegulation: number = 0;
  coPActivationFonctionProtectionDebitRemplissage: number = 0;
  coPActivationFonctionProtectionDebitVidange: number = 0;
  coPResetCompteurConsommation: number = 0;
  coPActivaterRemplissage: number = 0;
  coPActivaterVidange: number = 0;
  coPActivationFonctionSecuriteRemplissage: number = 0;
  coPActivationFonctionSecuriteVidange: number = 0;
  coPActivationRemplissageTotal: number = 0;
  coPActivationVidageTotal: number = 0;
  coPValeurNiveauEauMinAlarme: number = 0;
  coPValeurNiveauEauMaxAlarme: number = 0;
  coPDureeMaximumOuvertureVanneRemplissage: number = 0;
  coPDureeMaximumOuvertureVanneVidange: number = 0;

  coSTempssousTension: number = 0;
  coSCompteurBouton: number = 0;
  coSCompteurCommutationRemplissage: number = 0;
  coSCompteurCommutationVidange: number = 0;
  coSDebutPlageTemporellePossibleCalibration: number = 0;
  coSReponseDemandeCalibration: number = 0;
  coSStatutVanneRemplissage: number = 0;
  coSStatutVanneVidange: number = 0;
  coSModeTest: number = 0;
  coSMesureNiveauEau: number = 0;
  coSMesureNiveauEauMax: number = 0;
  coSMesureNiveauEauMin: number = 0;
  coSAlarmAbscenceProduit: number = 0;
  coSAlarmTempsRemplissageMaximum: number = 0;
  coSAlarmTempsVidangeMaximum: number = 0;
  coSAlarmBatterieCapteur: number = 0;
  coSAlarmSignalCapteur: number = 0;
  coSSecuriteDeconnexionProduit: number = 0;
  coSAlarm: number = 0;
  coSAlarmNiveauMax: number = 0;
  coSAlarmNiveauMin: number = 0;

  coSDisponibiliteDetectionDebit: number = 0;
  coSDebitReference: number = 0;
  coSDureeContinueOuvertureVanneRemplissage: number = 0;
  coSDureeContinueOuvertureVanneVidange: number = 0;
  coSMesureBatterieCapteur: number = 0;
  coSMesureSignalCapteur: number = 0;
  coSVolumeEauRempli: number = 0;
  coSVolumeEauVidange: number = 0;
  coSCompteurResetUsine: number = 0;
}

export class P00076 extends IProduct {
  override deviceTableIndex: number = 29;

  override modelIdentifier?: string = 'P00076';

  override dataIdentifier?: string = 'P00076';

  override manufacturerName?: string = 'ACWA';

  data: P00076Data = new P00076Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00076/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00076/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00076/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00076;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00076?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00076.tuto.installation.help.title',
      helpSlides: [
        'P00076.tuto.installation.help.1',
        'P00076.tuto.installation.help.2',
        'P00076.tuto.installation.help.3',
        'P00076.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00076/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00076/installation-1_dark.png',
          },
          text: 'P00076.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00076/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00076/installation-2_dark.png',
          },
          text: 'P00076.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00076/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00076/installation-1_dark.png',
          },
          text: 'P00076.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00076/update-2.png',
            dark: '/assets/ecosystem/images/products/P00076/update-2_dark.png',
          },
          text: 'P00076.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00076InstallationVannesComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00076InstallationConsommationComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00076InstallationVoletImmergeComponent,
            condition: (pool) => {
              return new P00039().hasProduct(pool, new P00042()) === 0;
            },
          },
        ],
        finish: P00076InstallationFinish,
        reset: P00076InstallationReset,
      },
      controlCards: [
        { component: P00076CardConstanceControleComponent, weight: 35 },
      ],

      statusCards: [
        { component: P00076CardConstanceStatutComponent, weight: 5 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.WATER_LEVEL];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.WATER_LEVEL ||
      functionnality == EventProductFunctionnalityEnum.WATER_LEVEL
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00076ConstanceMiseEnOeuvreNiveauEauComponent,
              condition: () => {
                return true;
              },
            },
          ],
          init: P00076ConstanceMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00076ConstanceControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00076ConstanceParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00076ConstanceStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00076.historique.consommation',
                mode: HistoryGraphModeEnum.DATA,

                customGraph: {
                  axesX: ['remplissage', 'vidange'],
                  properties: ['coSVolumeEauRempli', 'coSVolumeEauVidange'],
                },
                customGraphComponent: P00076FunctionHistoryGraphComponent,
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.HOUR,
                yModeOptions: {
                  max: 100,
                  min: -100,
                },
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Constance_Control,
      propertyName: 'coCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).coIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
